/**
 * Object.keys() retournant une liste typée de clés.
 *
 * Nativement, `Object.keys` retourne une liste de string (string[]) qu'il faut alors cast chaque fois au besoin.
 * La fonction ci-dessous simplifie le développement au quotidien en faisant lui-même le type casting,
 * rendant ainsi prévisible chaque fois le type de retour.
 */
export default function getObjectKeys<T extends object>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof typeof obj>;
}
